module.exports = __webpack_public_path__ + "img/llegado.79a32e54.svg";